module.exports = __webpack_public_path__ + "static/media/header_album_kazehayad5bdc1992b89f8c095e8875fd23aa9ac.webp";